import { Icon, IconColor, IconID, IconSize } from 'packages/radiant-react/icon';
import { Horizontal } from 'packages/radiant-react/layout';
import React, { useState } from 'react';
import styles from './styles.module.scss';
import cx from 'classnames';

interface ResetButtonWrapperProps {
  children: any;
  updateVariableValue: (value: any) => void;
  variableName: string;
}

const ResetButtonWrapper = ({
  children,
  updateVariableValue,
  variableName,
}: ResetButtonWrapperProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Horizontal onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      {children}
      <button
        className={cx(styles.resetButton, isHovered && styles.resetButtonHovered)}
        onClick={() => {
          updateVariableValue(undefined);
        }}
        title={`Reset ${variableName} to default value`}
      >
        <Icon id={'cross' as IconID} size={IconSize.SMALL} color={IconColor.DARKGRAY} />
      </button>
    </Horizontal>
  );
};

export default ResetButtonWrapper;
